// extracted by mini-css-extract-plugin
export var container = "referralModal-module--container--40569";
export var modalCloseButton = "referralModal-module--modalCloseButton--4efe2";
export var noScroll = "referralModal-module--no-scroll--6af0d";
export var referralModal = "referralModal-module--referralModal--29d81";
export var text = "referralModal-module--text--6f3c0";
export var title = "referralModal-module--title--410d5";